module.exports = __webpack_public_path__ + "img/Google.309a5e1d.png";